export const getCallbackUrl = () => {
  let port = "";
  if (
    window.location.port &&
    window.location.port !== "" &&
    window.location.port !== "80"
  ) {
    port = `:${window.location.port}`;
  }
  const BASE_URL = `${window.location.protocol}//${window.location.hostname}${port}`;
  const LINKING_CALLBACK_PATH = "/auth/linking-callback";

  return `${BASE_URL}${LINKING_CALLBACK_PATH}`;
};
